import { urlUtil } from '@cmg/common';

export const systemSubdomain = 'system';
/**
 * checks if the current subdomain is system (system administrator)
 */
export const isSystemSubdomain = () =>
  urlUtil.getAccountSubdomain(window.location) === systemSubdomain;
